// Where the venue switch in the top bar sends the browser.
//
// Changing venue while looking at one booking, one event or one conversation would leave the page
// showing a record the newly chosen venue does not hold, so the switch takes the browser back to
// the root of the section it is in, where that venue's list is. A root is left where it is: the
// list re-reads for the new venue by itself. Pages the venue never narrows (the dashboard,
// settings, integrations, the profile, the operator console) are left alone too.

const scopedSections = [
  "/bookings",
  "/calendar",
  "/events",
  "/venues",
  "/contacts",
  "/emails",
  "/finance",
  "/sponsors",
  "/vendors",
  "/inventory",
  "/analytics",
  "/portal-inbox",
] as const;

// Pages under a scoped section that describe the organisation rather than a venue. The mailboxes,
// the templates and the automation rules are shared by every venue, so a venue change must not
// pull somebody out of the rule they are writing.
const organisationPages = ["/emails/mailboxes", "/emails/templates", "/emails/automation"];

function within(path: string, prefix: string): boolean {
  return path === prefix || path.startsWith(`${prefix}/`);
}

/**
 * The section root the browser should return to after a venue change, or null when the current
 * page should be left where it is.
 */
export function sectionRootAfterVenueChange(pathname: string): string | null {
  const path = pathname.replace(/\/+$/u, "") || "/";
  if (organisationPages.some((page) => within(path, page))) return null;
  const root = scopedSections.find((section) => within(path, section));
  if (!root || path === root) return null;
  return root;
}
